interface MyButtonProps {
  /** The text to display inside the button */
  template: string;
  /** Whether the button can be interacted with */
  parts: {[k:string]:string}
}

let slice_to_max_length = (s: string,max:number) => {
    if(s.length > max){
	return s.slice(0,max) + '..'
    }
    return s
}
let get_buildingpart = (p: {[k:string]:string}) => {

    return p.buildingpart === "" ? null : (<span> (voor <b>{p.buildingpart}</b>)</span>)
}

function Styled_label({ template, parts}:MyButtonProps){
    let p = parts
    if(template === "quotation-step"){
	let supplier = (<b>{p.supplier}</b>)
	if(p.maatregel === undefined){
	    return (<span>{p.pre} van {p.date}, aan leverancier </span>)
	}
	let maatregel = slice_to_max_length(p.maatregel,60)
	return (<span>{p.pre} voor <b>{maatregel}</b> voor <b>{p.subtopic}</b> van {p.date}, aan leverancier {supplier}</span>)
    }else if(template === "hd-block-generic"){
	let prep = p.preposition
	let bd = get_buildingpart(p)
	if(prep === ''){
	    return (<span><b>{p.ddblock}</b>: <b>{p.subtopic}</b></span>)
	}
	return (<span><b>{p.prefix}{p.ddblock}</b> {p.preposition}: <b>{p.subtopic}</b>{bd}</span>)
    }else if(template === "implementation-step"){
	let buildingpart = get_buildingpart(p)
	let supplier = (<b>{p.supplier}</b>)
	return (<span>{p.pre} van <b>{p.maatregel}</b> voor <b>{p.subtopic}</b>{buildingpart}, aan leverancier {supplier}</span>)
    }else if(template === "chosen-measure"){
	let maatregel = slice_to_max_length(p.maatregel,60)
	let topic = p.subtopic === "" ? null : (<span> voor <b>{p.subtopic}</b></span>)
	return (<span>{p.pre} <b>{maatregel}</b> {topic}</span>)

    }else if(template === "subtopic-building"){
	let buildingpart = get_buildingpart(p)
	if(p.pre === ""){
	    return (<span>{p.pre}<b>{p.subtopic}</b>, voor Woningonderdeel <b>{p.buildingpart}</b></span>)
	}
	return (<span>{p.pre}<b>{p.subtopic}</b>{buildingpart}</span>)

    }else{
	return (<span>unknown template {template}</span>)
    }
}

export default Styled_label



